module.exports = __webpack_public_path__ + "static/img/99052A_02_20170621_LC.635ab1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/99052A_02_20170621_LC.png
// module id = RNiV
// module chunks = 0